import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];

export const scrollToSection = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -80, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 h-20 flex items-center border-b transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-[#F2F2F0]/90 backdrop-blur-xl border-[#111111]/15"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <button
          data-testid="logo-button"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="flex items-center group"
        >
          <img
            src="/assets/logo-dark.png"
            alt="One Piece Maintenance — For all your Plumbing needs"
            data-testid="logo-image"
            className="h-11 md:h-14 w-auto transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </button>

        <nav className="hidden md:flex items-center gap-10" data-testid="main-nav">
          {NAV.map((item) => (
            <button
              key={item.href}
              data-testid={`nav-${item.label.toLowerCase()}-link`}
              onClick={() => scrollToSection(item.href)}
              className="relative text-sm font-semibold uppercase tracking-[0.15em] text-[#111111]/70 hover:text-[#111111] transition-colors duration-300 after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#003BFF] after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-6">
          <a
            href="tel:+61452028256"
            data-testid="header-phone-link"
            className="hidden lg:flex items-center gap-2.5 text-sm font-extrabold tracking-wide hover:text-[#003BFF] transition-colors duration-300"
          >
            <span className="w-8 h-8 rounded-full bg-[#003BFF] flex items-center justify-center">
              <Phone className="w-3.5 h-3.5 text-white" />
            </span>
            0452 028 256
          </a>
          <button
            data-testid="header-quote-button"
            onClick={() => scrollToSection("#contact")}
            className="bg-[#111111] text-white rounded-full px-6 py-3 text-xs font-bold uppercase tracking-[0.15em] hover:bg-[#003BFF] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            Get a Quote
          </button>
        </div>
      </div>
    </motion.header>
  );
}
